module.exports = __webpack_public_path__ + "static/media/highlighted-text-instance.1337b74c.png";